import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { status } = {}) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
    '& button': {
      fontSize: 14,
      height: 34,
      minWidth: 10,
      paddingLeft: 4,
      paddingRight: 4,
      '&:nth-child(1)': {
        color:
          status === 'reject' ? theme.palette.primary2 : theme.palette.primary1,
        pointerEvents: status === 'reject' ? 'none' : 'initial',
      },
      '&:nth-child(2)': {
        backgroundColor:
          status === 'approve'
            ? `${theme.palette.primary2} !important`
            : `${theme.palette.primary1} !important`,
        fontSize: 12,
        minWidth: 72,
      },
    },
    [theme.breakpoints.down('md')]: {
      '& button': {
        fontSize: '10px !important',
      },
    },
  },
}));
